<div class="content">
  <title>{{ 'UNAUTHORIZED.SITE_MAINTENANCE' | translate }}</title>
  <article>
    <h1>{{ 'UNAUTHORIZED.OOPS' | translate }}</h1>

    <ng-container [ngSwitch]="unauthorizedType">
      <div *ngSwitchCase="'1'">
        <div class="mt-4">
          {{ 'UNAUTHORIZED.NO_ACCESS' | translate }}
          <a href="home#contact"> {{ 'UNAUTHORIZED.CLICK_HERE' | translate }}</a> {{ 'UNAUTHORIZED.TO_GET_ACCESS' | translate }}
        </div>
      </div>
      <div *ngSwitchCase="'2'">
        <p class="mt-4">
          {{ 'UNAUTHORIZED.REQUEST_NOT_APPROVED' | translate }}
        </p>
        <p class="mt-4">
          {{ 'UNAUTHORIZED.TRY_AGAIN_LATER' | translate }}
          <a target="_blank" href="mailto:{{ supportTeamMail }}">{{
            supportTeamMail
          }}</a>
          {{ 'UNAUTHORIZED.WILL_HELP_SHORTLY' | translate }}
        </p>
      </div>

      <div *ngSwitchCase="'3'">
        <p class="mt-4">{{ 'UNAUTHORIZED.REQUEST_REJECTED' | translate }}</p>
        <p class="mt-4">
          {{ 'UNAUTHORIZED.FURTHER_ASSISTANCE' | translate }}
          <a target="_blank" href="mailto:{{ supportTeamMail }}">{{
            supportTeamMail
          }}</a>
          {{ 'UNAUTHORIZED.WILL_HELP_SHORTLY' | translate }}
        </p>
      </div>

      <div *ngSwitchCase="'4'">
        <p class="mt-4">{{ 'UNAUTHORIZED.ACCESS_REVOKED' | translate }}</p>
        <p class="mt-4">
          {{ 'UNAUTHORIZED.FURTHER_ASSISTANCE' | translate }}
          <a target="_blank" href="mailto:{{ supportTeamMail }}">{{
            supportTeamMail
          }}</a>
          {{ 'UNAUTHORIZED.WILL_HELP_SHORTLY' | translate }}
        </p>
      </div>

      <div *ngSwitchCase="'ai-imagery-access'">
        <p class="mt-4">
          {{ 'UNAUTHORIZED.NO_ACCESS' | translate }}
        </p>
        <p class="mt-4">
          {{ 'UNAUTHORIZED.FURTHER_ASSISTANCE' | translate }}
          <a target="_blank" href="mailto:{{ supportTeamMail }}">{{
            supportTeamMail
          }}</a>
          {{ 'UNAUTHORIZED.WILL_HELP_SHORTLY' | translate }}
        </p>
      </div>
    </ng-container>
  </article>
</div>
